export default [
  'Cavities/Toothache',
  'Digit sucking/Dummy sucking',
  'Bleeding Gums on brushing teeth',
  'Tongue thrusting',
  'Complications during/after extractions',
  'Nail biting / Lip biting',
  'Clicking / pain in TMJ',
  'Mouth breathing',
  'Trauma to face/teeth/jaws',
  'Bruxism',
]
